module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG6fcc2a468bc54aa0a3d966eddbfce04d.6fcc2a46.png";